export const environment = {
  production: true,
  apiUrl: "https://dev.api.catexpert.ab-inbev.com/qa/",
  baseUrlV2: "https://dev.api.catexpert.ab-inbev.com/qa/projects/api/v2",
  baseUrlV3: "https://dev.api.catexpert.ab-inbev.com/qa/projects/api/v3",
  baseUrl: "https://dev.api.catexpert.ab-inbev.com/qa/projects/api/",
  basePlanoUrl: "https://dev.api.catexpert.ab-inbev.com/qa/planogram/",
  baseProductUrl: "https://dev.api.catexpert.ab-inbev.com/qa/product/",
  url: "https://dev.api.catexpert.ab-inbev.com/qa/reference/api/v1/",
  edaurl: "https://dev.api.catexpert.ab-inbev.com/qa/eda/api/v1/",
  edaurlV2: "https://dev.api.catexpert.ab-inbev.com/qa/assortment/api/v1/",
  expurl: "https://dev.api.catexpert.ab-inbev.com/qa/process/api/v1/",
  simulationurl: "https://dev.api.catexpert.ab-inbev.com/qa/simulation/api/v1/",
  userUrl: "https://dev.api.catexpert.ab-inbev.com/qa/user/api/v1/",
  userUrlV3: "https://dev.api.catexpert.ab-inbev.com/qa/user/api/v3/",
  phoBaseUrl: "https://dev.api.catexpert.ab-inbev.com/qa/pho/api/v1",
  socketBaseUrl: "http://localhost:3000",
  socketCommonPath: "/api/v1/",
  imageUrl: `https://cdn.catexpert.ab-inbev.com/planogram/`,
  colorUrl: `https://catexpertstorage2.blob.core.windows.net/assets/highlight_colors/highlight_color.json`,
  powerBIDasboardURL:
    "https://app.powerbi.com/links/YO2x5XKUhQ?ctid=cef04b19-7776-4a94-b89b-375c77a8f936&pbi_source=linkShare&bookmarkGuid=352c22c7-25b4-46db-86a6-6fe63f874a68",
  assortmentUrl: `https://dev.api.catexpert.ab-inbev.com/qa/assortment/api/v1/`,
  goProcess: `https://dev.api.catexpert.ab-inbev.com/qa/go-process/tasks/`,
  goProcessStates: `https://dev.api.catexpert.ab-inbev.com/qa/go-process/refs/`,
  goProcessDownload: `https://dev.api.catexpert.ab-inbev.com/qa/go-process/`,
  planogramWebsocketUrl: "wss://dev.api.catexpert.ab-inbev.com/qa/ws/planogram",
  fixtureWebsocketUrl:
    "wss://dev.api.catexpert.ab-inbev.com/qa/product/ws/fixtures",
  aiImageUrl: `https://cdn.catexpert.ab-inbev.com/assets/`,
};
